define('lq/conditions/operandEvaluator',[
    'jquery',
    'lq/types'
], function ($, types) {

    var validGuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    
    var secondValueShouldFallbackToEmptyString = function (first, second) {
        return types.isString(first) && second == null;
    };

    var valueShouldBeConvertedToNull = function (theValue) {
        if (theValue === null) return false;

        return theValue === '' ||
            theValue === undefined

            // we used to do "==" instead of "===" when evaluating conditions
            // [] == "" will return true, but [] === "" won't => breaks compatibility
            ||
            (Array.isArray(theValue) && theValue.length === 0);
    };

    var evaluationHandlers = {
        '=': function (left, right) {
            if (valueShouldBeConvertedToNull(left)) left = null;
            if (valueShouldBeConvertedToNull(right)) right = null;

            return left === right;
        },
        '≠': function (left, right) {
            if (valueShouldBeConvertedToNull(left)) left = null;
            if (valueShouldBeConvertedToNull(right)) right = null;

            return left !== right;
        },
        '>': function (left, right) {
            return left > right;
        },
        '≥': function (left, right) {
            return left >= right;
        },
        '≤': function (left, right) {
            return left <= right;
        },
        '<': function (left, right) {
            return left < right;
        },
        'contains': function (left, right) {
            var leftString = String(left).toLowerCase();
            var rightString = String(right).toLowerCase();
            return leftString.indexOf(rightString) != -1;
        }
    };

    var OperandEvaluator = function (operand) {
        $.extend(this, operand);
    };

    OperandEvaluator.isCurrentContext = function (operandValue) {
        return operandValue.typeOfValue === 'CurrentContext';
    };

    OperandEvaluator.isQueryOutput = function (operandValue) {
        return operandValue.typeOfValue === 'Query';
    };

    OperandEvaluator.isValue = function (operandValue) {
        return operandValue.typeOfValue === 'Value';
    };

    OperandEvaluator.isBoolean = function (operandValue) {
        return operandValue.typeOfValue === 'Boolean';
    };

    OperandEvaluator.isParameter = function (operandValue) {
        return operandValue.typeOfValue === 'Parameter';
    };

    OperandEvaluator.isViewData = function (operandValue) {
        return operandValue.typeOfValue === 'View';
    };

    OperandEvaluator.prototype.evaluate = function (queryResults, piping, currentContextValue) {
        var left = this.getValue(this.leftValue, queryResults, piping, currentContextValue);
        var right = this.getValue(this.rightValue, queryResults, piping, currentContextValue);

        // Makes sure that 'tRue', 'True' etc. all get converted to boolean true
        var leftBooleanTry = this.tryConvertBoolean(left);
        var rightBooleanTry = this.tryConvertBoolean(right);
        if (this.isBoolean(leftBooleanTry) && this.isBoolean(rightBooleanTry)) {
            left = leftBooleanTry;
            right = rightBooleanTry;
        } else if (this.isGuid(left) && this.isGuid(right)) {
            left = left.toLowerCase();
            right = right.toLowerCase();
        }

        if (secondValueShouldFallbackToEmptyString(left, right)) {
            right = '';
        } else if (secondValueShouldFallbackToEmptyString(right, left)) {
            left = '';
        } else if ($.isNumeric(left) && $.isNumeric(right)) {
            left = Number(left);
            right = Number(right);
        } else if (types.isDate(left) && types.isDate(right)) {
            left = new Date(left).getTime();
            right = new Date(right).getTime();
        } else if (types.isBoolean(left) && types.isString(right)) {
            if (right)
                right = types.parseBoolean(right);
            else
                right = !left;
        } else if (types.isBoolean(right) && types.isString(left)) {
            if (left)
                left = types.parseBoolean(left);
            else
                left = !right;
        }

        var evaluator = evaluationHandlers[this.operator];
        return evaluator(left, right);
    };

    OperandEvaluator.prototype.isGuid = function(v) {
        return typeof v === 'string' && validGuid.test(v.toLowerCase());
    };

    OperandEvaluator.prototype.isBoolean = function(v) {
        return typeof v === 'boolean';
    };

    OperandEvaluator.prototype.tryConvertBoolean = function(b) {
        if (typeof b !== 'string')
            return b;
        if (b.toLowerCase() === 'true')
            return true;
        else if (b.toLowerCase() === 'false')
            return false;
        return b;
    };

    OperandEvaluator.prototype.getValue = function (operandValue, queryResults, piping, currentContextValue) {
        if (OperandEvaluator.isViewData(operandValue))
            return piping.dropFactory
                .findDropByViewModelKey(operandValue.viewModelKey)
                .getValue();

        if (OperandEvaluator.isParameter(operandValue))
            return piping.parameters.getValue(operandValue.fixedValue);

        if (OperandEvaluator.isQueryOutput(operandValue))
            return queryResults[operandValue.query][operandValue.output];

        if (OperandEvaluator.isValue(operandValue))
            return operandValue.fixedValue;

        if (OperandEvaluator.isBoolean(operandValue)) {
            return !!operandValue.boolean;
        }

        if (OperandEvaluator.isCurrentContext(operandValue))
            return currentContextValue;

        throw Error('Don\'t know what to do with "' + operandValue.typeOfValue + '".')
    };

    return OperandEvaluator;
});
